import React, { useEffect, useRef } from 'react';

import './styles.scss';

const SearchInput = ({
  dropDownItems,
  dropDownElement,
  leftIcon,
  rightIcon,
  label,
  dropDownContainerClassName = '',
  closeDropdown,
  required,
  highlighted,
  notFoundElement,
  dropDownMaxHeight = '250px',
  searchInputWrapperStyle = {},
  searchInputContainerStyle = {},
  value,
  loading = false,
  dropdownWidth = 0,
  loadingElement = null,
  ...rest
}) => {
  const containerRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target) && dropDownItems?.length > 0) {
        closeDropdown?.();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [closeDropdown]);

  const dropdownFinalWidth =
    dropdownWidth > 0 ? dropdownWidth : containerRef.current?.clientWidth ? containerRef.current?.clientWidth : 0;

  return (
    <div ref={containerRef} className="search-input-container" style={searchInputContainerStyle}>
      {label?.length > 0 && (
        <label className="search-input-label">
          {label}
          {required && <span className="search-input-required">*</span>}
        </label>
      )}
      <div
        className="search-input"
        style={{
          borderColor: highlighted || value?.length > 0 || dropDownItems?.length > 0 ? 'var(--purple-p-400)' : '',
          ...searchInputWrapperStyle,
        }}>
        {leftIcon}
        <input type="text" value={value} {...rest} />
        {rightIcon}
      </div>
      {dropDownItems.length === 0 && notFoundElement && value?.length && !loading ? (
        <div style={{ width: dropdownFinalWidth }} className={`search-input-drop-down ${dropDownContainerClassName}`}>
          {notFoundElement}
        </div>
      ) : loadingElement && loading ? (
        <div style={{ width: dropdownFinalWidth }} className={`search-input-drop-down ${dropDownContainerClassName}`}>
          {loadingElement}
        </div>
      ) : (
        <></>
      )}
      {dropDownItems?.length > 0 && (
        <div
          style={{
            width: dropdownFinalWidth,
            maxHeight: dropDownMaxHeight,
          }}
          className={`search-input-drop-down ${dropDownContainerClassName}`}>
          {dropDownItems.map((item, index) => dropDownElement({ item, index, key: index }))}
        </div>
      )}
    </div>
  );
};

export default SearchInput;
